import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, BrowserRouter as Router } from 'react-router-dom';

import 'app/App.scss';
import 'fonts/fonts';

import Home from 'app/screens/Home';

import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl'
import { resizeScreen } from 'shared/actions/screenActions';

class App extends Component {

  constructor(props){
    super(props);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.props.resizeScreen(window.innerWidth, window.innerHeight);
  }

  render() {
    const { locale, messages } = this.props;

    return (
      <div className="App">
        <IntlProvider defaultLocale="en" locale={locale} messages={messages}>
          <Router>
            <Route exact path="/">
              <Home />
            </Route>
            <Route exact path="/gallery/:token">
              <Home />
            </Route>
            <Route exact path="/404">
              <p>Not found.</p>
            </Route>
          </Router>
        </IntlProvider>
      </div>
    );
  }
}

App.propTypes = {
  resizeScreen: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  messages: state.messagesReducer.messages,
  locale: state.messagesReducer.locale,
});

export default connect(null, { resizeScreen })(App);
